import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../data/images';
import { HeroSculpture } from '../three/HeroSculpture';
import { ButtonLink } from '../ui/ButtonLink';
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 14
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }
  }
};
const focusAreas = ['Executive & C-Suite Search', 'Board & Non-Executive Directors', 'Confidential Assignments'];
export function HomeHero() {
  return <section className="on-dark relative overflow-hidden bg-aubergine text-porcelain" data-id="element-211" data-mp="31v12h1d9p7za">
      <div className="mx-auto grid max-w-7xl items-center gap-6 px-6 pt-32 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:pt-36" data-id="element-212" data-mp="2n27mleu32pu3">
        <motion.div className="relative z-10 lg:col-span-6" variants={container} initial="hidden" animate="show" data-id="element-213" data-mp="3fszcxvogwk9i">
          <motion.p variants={item} className="font-serif text-xl italic text-copper-light" data-id="element-214" data-mp="3kk7rf64nmvtj">
            Strategic Search. Meaningful Connections. Lasting Impact.
          </motion.p>
          <motion.h1 variants={item} className="mt-6 text-[2.75rem] font-semibold leading-[1.04] tracking-tight sm:text-6xl xl:text-[4.5rem]" data-id="element-215" data-mp="jw4e22t8flv7">
            Exceptional Leaders.{' '}
            <span className="font-serif font-medium italic text-copper-light" data-id="element-216" data-mp="swapzk9a8ds9">Extraordinary</span> Possibilities.
          </motion.h1>
          <motion.p variants={item} className="mt-8 max-w-xl text-lg leading-relaxed text-porcelain/75" data-id="element-217" data-mp="17k5j31r7ck5v">
            Aurevane Search Partners connects ambitious organizations with exceptional leadership talent. Through a thoughtful, relationship-driven approach to executive search, we help organizations identify the people who will shape their next chapter of growth.
          </motion.p>
          <motion.div variants={item} className="mt-10 flex flex-wrap gap-4" data-id="element-218" data-mp="3iejisvcl4wqa">
            <ButtonLink to="/employers#inquiry" size="lg" data-id="element-219" data-mp="3ecyalnazx6mf">
              Discuss Your Hiring Needs
            </ButtonLink>
            <ButtonLink to="/expertise" variant="outline-light" size="lg" data-id="element-220" data-mp="1hctyk1cjyz1u">
              Explore Our Expertise
            </ButtonLink>
          </motion.div>
        </motion.div>
        <div className="h-[340px] sm:h-[460px] lg:col-span-6 lg:h-[620px]" data-id="element-221" data-mp="1r9gimnx21m2t">
          <HeroSculpture fallbackSrc={images.heroFallback} data-id="element-222" data-mp="1w8ji7su9n03e" />
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-223" data-mp="20aegeogwgxcy">
        <ul className="grid border-t border-porcelain/10 sm:grid-cols-3" data-id="element-224" data-mp="209v901ovlrd6">
          {focusAreas.map((area, i) => <li key={area} className={`py-6 text-sm font-medium text-porcelain/70 sm:py-8 ${i > 0 ? 'border-t border-porcelain/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-225" data-mp="257oawij5bz7n" data-mpi={i}>
              {area}
            </li>)}
        </ul>
      </div>
    </section>;
}